<template>
  <!--商品详情页-->
<div>
  <!--顶部搜索-->
  <topSearch></topSearch>
  <div>
    <div class='show_wrapper' >

      <img   :src='good.pict_url' class="goods_pic" />
      <!--video v-if="good.isVideo=='1'" :src='good.videoURL' :poster='good.goodsPic' class="goods_pic"></video-->
      <div class="good_des_wrapper">
        <div class='title_wrapper'>
          <div class='title' >{{good.title}}</div>
        </div>
        <div class='shop_wrapper'>
          <div class='shop'>
            <img src="../../images/tmallSelected.png"  v-if="good.user_type=='1'" class='n_goods_shop_img'/>
            <img src="../../images/taobao.png"  v-if="good.user_type=='0'" class='n_goods_shop_img' />
            <!--img src="../../images/haitao.png"  v-if="dataList.isHaiTao==1" class='n_goods_shop_img' />
            <img src="../../images/juhuasuan.png"  v-if="dataList.isJuHuaSuan==1" class='n_goods_shop_img' />
            <img src="../../images/taoqianggou.png"  v-if="dataList.isTaoQiangGou==1" class='n_goods_shop_img' />
            <img src="../../images/video.png"  v-if="dataList.isVideo==1" class='n_goods_shop_img'/-->
            <span class='shop_name'>{{good.nick
!=''?good.nick:shopName}}</span>
          </div>
        </div>
        <div class='coupons_wrapper' v-if = "coupon">
           <div class='coupons'>
             <span class='coupons_icon'><span class='left_circle'></span>券后<span class='right_circle'></span></span>
             <span class='coupons_money'><span class="coupons_money_icon">￥</span>{{good.finalPrice}}</span>
             <span class='coupons_currentmoney'>{{good.zk_final_price}}</span>
           </div>
           <!--div class='coupons_people_num'>31452人已买</div-->
         </div>
           <div class='get_coupons_wrapper' v-if = "coupon">
             <div class='get_coupons' v-if = "good.couponPrice>0">
                <div class='get_coupons_l'>
                 <div class='get_coupons_money_num'>{{good.couponPrice}}元优惠券 </div>
                 <!--div class='get_coupons_end_time'>距结束 {{good.endTime}}</div>
                 <div class='get_coupons_persent'>
                   <div class='get_coupons_alreadypersent' :style="{width:couponRatio*2.85+'px'}"></div><2。85  为总长度除以100-->
                   <!--div class='get_coupons_alreadypersen_num'>{{couponRatio}}%</div>
                 </div-->
                </div>
                <div class='get_coupons_r'>
                   <div class="circle_line">
                   <div class="circle1"></div>
                   <div class="line"></div>
                   <div class="circle2"></div>
                 </div>
                 <div class='get_coupons_btn'   @click="getCoupon">立即领券</div>
                </div>
             </div>
          </div>
          <!--推荐理由
           <div class='good_commend_reason'>
          <span class='good_commend_reason_text'>推荐理由：</span>{{good.comment}}
        </div>-->
        <!--展开商品详情-->
        <div class='goods_details_pics_show' v-show='!goodsDetail' @click="goodsDetailShow">
       <span class='goods_details_btn goods_details_btn_color'>展开商品详情</span>
       <p class='icon-bottom icon_top_position goods_details_icon_color'></p>
     </div>
      </div>
    </div>
    <!--商铺名称-->
    <!--shopName :item='good'></shopName-->
    <!--评论暂且关闭，不知道调用哪个表-->
    <!--commentList v-show='goodsDetail'></commentList-->
    <!--商品详情-->
    <goodsDetail v-show='goodsDetail' :images='good.smallPic' v-if="good.smallPic" :goodsDetailShow='goodsDetailShow'></goodsDetail>
    <!--其他优惠券-->
    <!--otherCoupon :goodsID="good.goodsID" :activityID = "good.activityID"></otherCoupon-->
    <!--大家都在看-->
    <everyBodySee :keyWord="good.babySeeWord" v-if="good.babySeeWord"></everyBodySee>
    <!--内容footer-->
    <div class='xm_footer'>
   <div class='xm_footer_l'>
     <div class='xm_f_tag'>
       <span class='icon-tag xm_f_tag_icon'></span>优惠券<span class='xm_f_tag_money_color'>￥</span>
     </div>
     <div class='xm_f_number'>{{good.couponPrice}}
     </div>
   </div>
   <div class='xm_footer_c'>
     <div class='xm_fc_back'>
       <span class='xm_fc_back1'>{{good.finalPrice}}</span>
       <span class='xm_fc_back2'>(券后)</span>
     </div>
     <div class='xm_fc_origin'>
       <span class='xm_fc_origin1'>原价：{{good.zk_final_price}}元</span>
     </div>
   </div>
   <div class='xm_footer_r'    @click="getCoupon">
       <span class='xm_get_q'>{{good.couponPrice>0?'点击领券':'点击购买'}}</span>
       <!--span class='xm_get_q'>请稍等</span-->
       <!-- <button class='m_get_q' open-type='share' loading='{{true}}' id="getCouponAfterShare" wx:if="{{good.couponOfferURL==null}}">{{good.money>0?'分享后领券':'分享赚券币'}}</button> -->
   </div>
 </div>
  </div>
  <!--回到淘券上-->
 <router-link to="/GoodsCoupon" class="goto_coupon">
   <div class="goto_coupon_conter">
     <p>回到</p>
     <p>首页</p>
   </div>
 </router-link>
  <mt-popup class="copyBox"
  v-model="copyBox"
  position="top" :closeOnClickModal= false :modal= true >
    <div class="copyBoxContainer">
      <strong class="title">领券方法</strong>
      <p class="greetings">点击“复制淘口令”后，打开手机淘宝领取优惠券</p>
    <div class="btn_wrapper">
      <button class="one_copy_btn copy_btn"  :data-clipboard-text="clipData" @click="getCouponCopy">复制淘口令</button>
      <button class="close_copy_btn copy_btn" @click="closeModal">关闭</button>
    </div>
    </div>
</mt-popup>
</div>
</template>
<script type = "text/ecamscript-6">
  //引入JQ
  import $ from "jquery"
  import Vue from "vue"
  import Clipboard from 'clipboard' //获取粘贴插件
  import axios from 'axios' //aoxis
  import { Popup,Toast } from 'mint-ui';
  Vue.component(Popup.name, Popup);
  import {getTimeDiff,addScore} from "../../common/js/common.js"//获取时间戳函数
  import TopSearch from '@/components/common/topSearch'
  import ShopName from '@/components/item/shopName'
  import CommentList from '@/components/item/commentList'
  import GoodsDetail from '@/components/item/goodsDetail'
  import OtherCoupon from '@/components/item/otherCoupon'
  import EveryBodySee from '@/components/item/everyBodySee'
    export default {
      name:"item",
      data(){
        return{
          item:[],
          goodsDetail:false,  //商品详情页显示
          hasTaoKouLing:false, //是否领券
          good:{},
          clipData:"初始值",//剪贴板内容
          copyBox:false,//是否显示淘口令复制窗口
          couponRatio:0,
          goodId:"",
          coupon:"",
          tkUrl:"",
          openID:'',
          clipboardFlag:false
        }
      },
      watch: {
      '$route' (to, from) {
        // 对路由变化作出响应...
        //this.good = this.$route.params.context
        // if(this.$route.params.context){//若路由有数据则从路由读取，否则从vuex的本地储存读出来
        //   this.$store.dispatch("getLocalContent",this.$route.params.context)
        // }
        // this.good =JSON.parse(localStorage.localContent)
        this.goodId = this.$route.params.id
        this.coupon = this.$route.query.coupon;
        this.tkUrl = this.$route.query.tkUrl;
        this.login()
      }
    },
      components:{
        'topSearch':TopSearch,
        'shopName':ShopName,
        'commentList':CommentList,
        'goodsDetail':GoodsDetail,
        'otherCoupon':OtherCoupon,
        'everyBodySee':EveryBodySee
      },
      created(){

        this.goodId = this.$route.params.id
        this.coupon = this.$route.query.coupon;
        //console.log(this.coupon)
        this.tkUrl = this.$route.query.tkUrl;
        this.login()
      },
      methods:{
        login () {
          this.url = "api/getItemInfoFromAPI.php?goodsID="+this.goodId
          //console.log(this.url )
          this.$ajax.autoService
              .login(this.url)
              .then((res) => {
                this.good = res.data.results.n_tbk_item
                //console.log(this.good)
                //this.good.endTime = getTimeDiff(this.good.coupon_end_time)
                //this.good.couponPrice = parseInt(this.good.couponPrice)
                // this.couponRatio = parseInt(((this.good.coupon_total_count-this.good.coupon_remain_count)/this.good.coupon_total_count)*100)
                this.good.couponPrice  = this.coupon;
                this.good.finalPrice = this.good.zk_final_price-this.good.couponPrice
                this.good.babySeeWord = this.good.title.slice(0,5)
                this.good.smallPic = this.good.small_images.string

                  //console.log(res)
              }, (res) => {
                  console.log("error")
              })
         },
         //商品详情页显示
         goodsDetailShow () {
           this.goodsDetail = !this.goodsDetail
         },
         //点击领券
         getCoupon () {
           //let couponURL = this.good.couponURL
           let finalPID = "mm_14795599_154950051_44966700018"
           //console.log(this.good.coupon_id)
           let couponURL = "https:"+this.tkUrl+ '&pid=' + finalPID
           //console.log(couponURL)
           //let couponURL  = this.good.coupon_share_url
            //couponOfferURL = 'https://uland.taobao.com/coupon/edetail?activityId=' + this.good.activityID + '&itemId=' + this.good.goodsID + '&pid=' + finalPID + '&mt=1'
            let taoKouLing = ''//把领券地址变成淘口令
            if (!this.hasTaoKouLing) {  //还没有领券
         //还没有淘口令
         if (this.good.tbkURL && this.good.tbkURL.match(/￥.*?￥/)) {
         //如果商品信息中有淘口令
         //cnosole.log("yiyou")
         this.taoKouLing = this.good.tbkURL.match(/￥.*?￥/)[0]
         this.clipData = ''
         this.clipData = this.good.title + '\n\n'
         this.clipData = this.clipData + '商品价格:' + this.good.zk_final_price + '元\n'
         this.clipData = this.clipData + '优惠券:' + this.good.couponPrice + '元\n'
         this.clipData = this.clipData + '用券后:' + this.good.finalPrice + '元\n'
         this.clipData = this.clipData + '---------------------\n'
         this.clipData = this.clipData + '〖复制这条信息,打开[手机淘宝]即可领券并下单。' + this.taoKouLing + '〗\n'
         this.clipData = this.clipData + '---------------------\n'
         this.clipData = this.clipData + '★搜券王，帮你省钱的公众号★'
         this.copyBox = true

         } else {


         //let tUrl = "https://souquan.wang/api/getTaoFree.php?logo="+this.good.pict_url+"&text="+this.good.title+"&url="+couponURL//免费的淘口令接口，淘宝开放平台
         let tUrl ="https://souquan.wang/api/getTaoFree.php?logo="+encodeURIComponent(this.good.pict_url)+"&text="+encodeURIComponent(this.good.title)+"&url="+couponURL
         //console.log(tUrl)
         axios({
           method:"Get",
           url:tUrl
         }).then((res) => {
              //console.log(tUrl,res)
              //复制函数

              if (res.data && res.data.data && res.data.data.model) {
                var taoKouLing = null
                this.taoKouLing = res.data.data.model
                this.clipData = ''
                this.clipData = this.good.title + '\n\n'
                this.clipData = this.clipData + '商品价格:' + this.good.zk_final_price + '元\n'
                this.clipData = this.clipData + '优惠券:' + this.good.couponPrice + '元\n'
                this.clipData = this.clipData + '用券后:' + this.good.finalPrice + '元\n'
                this.clipData = this.clipData + '---------------------\n'
                this.clipData = this.clipData + '〖复制这条信息,打开[手机淘宝]即可领券并下单。' + this.taoKouLing + '〗\n'
                this.clipData = this.clipData + '---------------------\n'
                this.clipData = this.clipData + '★搜券王，帮你省钱的公众号★'
                this.copyBox = true

                // taoKouLing: taoKouLing,
                // hasTaoKouLing: true,
                // showTaoKouLing: true,
                // notShowShare: true
              }
            }, (res) => {
                console.log("error")
            })

         }

       } else {
      //已有了淘口令
      taoKouLing = this.taoKouLing
      var clipData = ''
      clipData = this.good.title + '\n\n'
      clipData = clipData + '商品价格:' + this.good.zk_final_price + '元\n'
      clipData = clipData + '优惠券:' + this.good.couponPrice + '元\n'
      clipData = clipData + '用券后:' + this.good.finalPrice + '元\n'
      clipData = clipData + '---------------------\n'
      clipData = clipData + '〖复制这条信息,打开[手机淘宝]即可领券并下单。' + taoKouLing + '〗\n'
      clipData = clipData + '---------------------\n'
      clipData = clipData + '★搜券王，帮你省钱的公众号★'
      this.copyBox = true
    }


     },
     getCouponCopy () {
       //复制函数
       if(sessionStorage.userInfo){
         this.openID=JSON.parse(sessionStorage.userInfo).openId
       }
       if(!this.clipboardFlag&&this.openID){
         var that = this;
       addScore('领券', this.openID, function (score) {
         Toast({
           message:"+"+score+"券币",
         })
         that.$store.dispatch('cancelScore',{total:that.$store.state.scoreUserInfo.totalScore*1,userScore:-score*1})
        })

     }
       var clipboard = new Clipboard('.copy_btn')
     //console.log(2)
        clipboard.on('success', e => {
          this.hasTaoKouLing=true
          this.copyBox = false
          // console.info('Text:', e.text);
          //console.log('复制成功')
          // 释放内存
          this.clipboardFlag=true
         clipboard.destroy()

        })
        clipboard.on('error', e => {
          // 不支持复制
          console.log('该浏览器不支持自动复制')
          // 释放内存
          clipboard.destroy()
        })
     },
     closeModal () {
       this.copyBox = false
     }

    },





  mounted () {


  },


  }
</script>
<style lang="stylus">
  .show_wrapper
    background:#fff
    .goods_pic
      width:100%
    .good_des_wrapper
      padding:20px 30px;
      .title_wrapper
        font-size:28px
        color:#333
        line-height:36px
      .shop_wrapper
        margin:5px 0;
        .n_goods_shop_img
          width:20px
          height:20px
          vertical-align:middle
        .shop_name
          font-size:22px
          color:#999
          line-height:20px
      .coupons_wrapper
        display: flex
        justify-content: space-between
        box-sizing: border-box
        font-size: 0px
        margin-top: 25px
        line-height: 30px
        .coupons_icon
          padding: 0 15px
          height: 30px
          font-size: 20px
          color: #fff
          background: linear-gradient(to right,#f80,#ff5100)
          display: inline-block
          position: relative
          line-height: 30px
          box-sizing: border-box
          vertical-align: middle
          .left_circle
            display: inline-block
            width: 6px
            height: 12px
            border-radius: 0 6px 6px 0
            background: #fff
            position: absolute
            left: 0px
            top: 9px
          .right_circle
            display: inline-block
            width: 6px
            height: 12px
            border-radius:6px 0 0 6px
            background: #fff
            position: absolute
            right: 0px
            top: 9px
        .coupons_money
            font-size: 40px;
            margin-left: 5px;
            color: #f40;
            vertical-align: middle
            margin-left:10px
            .coupons_money_icon
              font-size:20px
        .coupons_currentmoney
          font-size:22px
          color:#999
          text-decoration:line-through
          vertical-align:bottom
          margin-left:10px
      .get_coupons_wrapper
        margin-top: 30px
      .get_coupons
        height: 185px;
        background: linear-gradient(to right,#ff8800,#f40);
        border-radius: 10px;
        display: flex;
        .get_coupons_l
          flex: 1
          height: 185px
          .get_coupons_money_num
            color: #fff
            text-align: center
            font-size: 48px
            line-height:185px
          .get_coupons_end_time
            font-size: 20px
            color: #ffe27f
            text-align: center
          .get_coupons_persent
            width: 285px;
            height: 22px;
            background: #ffc333;
            line-height: 22px;
            text-align: center;
            font-size: 20px;
            color: #ff4a00;
            margin: 15px auto 0 ;
            border-radius: 11px;
            overflow: hidden;
            position: relative
            .get_coupons_alreadypersent
              background: #ffe27f;
              width: 180px;
              height: 22px;
            .get_coupons_alreadypersen_num
              width: 100%;
              text-align: center;
              position: absolute;
              left: 0px;
              top: 0px;
              padding-top: 3px;
        .get_coupons_r
          flex: 0 0 250px
          width: 250px
          position: relative
          height: 185px
          .circle_line
            position: absolute
            width: 24px
            height: 100%
            left: -12px
            top: 0px
            .line
              border-left: 2px dotted #dddddd
              height: 100%
              margin: 0 auto
              width: 0px
            .circle1
              width: 24px
              height: 12px
              background: #fff
              border-radius: 0 0 12px 12px
              top: 0px
              left: 0px
              position: absolute
            .circle2
              width: 24px
              height: 12px
              background: #fff
              border-radius: 12px 12px 0 0
              bottom: 0px
              left: 0px
              position: absolute
          .get_coupons_btn
            font-size:36px
            color:#fff
            width:100%
            height:100%
            line-height:185px
            text-align:center
            display:block
      .good_commend_reason
        font-size:22px
        color:#b49183
        margin-top:20px
      .goods_details_pics_show
        margin-top:30px
        .goods_details_btn_color
          color: #f40
          border: solid #f40 1px
          /*px*/
          margin-bottom: 5px
          display:block
          width: 250px
          height: 60px
          line-height: 60px
          border-radius: 30px
          font-size: 24px
          margin: 0 auto
          text-align:center
        .goods_details_icon_color
          color: #f40
          text-align:center
          margin-top:10px
  .xm_footer
    display: flex
    width: 100%
    margin-top: 20px
    position: fixed
    bottom: 0px
    left: 0px
    z-index:99999
    height:110px
    border-top: solid #ddd 1px
    /*px*/
    box-sizing:border-box
    .xm_footer_l
      width: 310px
      flex: 0 0 310px
      padding-left: 30px
      box-sizing: border-box
      background: #fff
      padding-top: 30px
      .xm_f_tag
        color: #333;
        font-size: 24rpx
        display:inline-block
        .xm_f_tag_icon
          color: #333
          line-height: 50px
          margin-right: 5px
        .xm_f_tag_money_color
          color: #f40
          margin-left: 10px
      .xm_f_number
        font-size: 56px
        font-weight: bold
        color: #f40
        line-height: 36px
        margin-right: 5px
        display:inline-block
    .xm_footer_c
      width: 220px
      flex: 0 0 220px
      height: 110px
      padding: 28px 0 0px 20px
      box-sizing: border-box
      background: #e5e5e5
      .xm_fc_back
        line-height: 25px
        height: 25px
        .xm_fc_back1
          font-size: 28px
          color: #333
          line-height: 25px
        .xm_fc_back2
          font-size: 24px
          color: #333
      .xm_fc_origin
        line-height: 35px
        height: 35px
        .xm_fc_origin1
          font-size: 20px
          color: #999
          text-decoration: line-through
    .xm_footer_r
      background-image: linear-gradient(90deg, #f80, #f40)
      flex: 1
      height: 110px
      .xm_get_q
        display:block
        font-size:28px
        color:#fff
        text-align:center
        line-height:110px
  .mint-popup
    &.copyBox
      width:100%
      height:100%
      background:none
    .copyBoxContainer
      width:500px
      padding:30px 0 0 0
      position:fixed
      left:50%
      top:50%
      z-index:999
      background:#fff
      transform:translate(-50%,-50%)
      border-radius:20px
      overflow:hidden
      .title
        font-size:34px
        color:#f40
        display:block
        text-align:center
      .greetings
        font-size:28px
        color:#333
        text-align:center
        margin-top:10px
      .btn_wrapper
        display:flex
        margin-top:20px
        border-top:1px solid #f0f0f0
        /*px*/
        .close_copy_btn
          flex:1
          height:80px
          line-height:80px
          font-size:30px
          background:none
          border:0px solid #f0f0f0
          border-left:1px solid #f0f0f0
          /*px*/
        .one_copy_btn
          flex:1
          height:80px
          line-height:80px
          font-size:30px
          color:#f40
          border:0px solid #f0f0f0
          background:none
  .goto_coupon
    width:100px
    height:100px
    border-radius:50px
    background:rgba(0,0,0,0.8)
    color:#fff
    position:fixed
    right:30px
    bottom:150px
    z-index:999
    text-align:center
    .goto_coupon_conter
      width:100%
      position:absolute
      left:50%
      top:50%
      transform:translate(-50%,-50%)
</style>

<style>
  .xm_get_q{
    font-size: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/item/item.vue